/** Prop values for campaign promo UI components (not copy/prices). */
export const LIMITED_TIME_OFFER_BANNER_VARIANT = Object.freeze({
  CHECKOUT: 'checkout',
  COMPACT: 'compact',
});

export const ELEVATED_PROMO_PRICE_ROW_LAYOUT = Object.freeze({
  SPLIT: 'split',
  INLINE: 'inline',
});
